import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { ErrorService, EventService } from '..';

import { ConfigService } from './config.service';
import {ProjectPlugin} from "../models";


@Injectable({ providedIn: 'root' })
export class MobileEventTypeProjectRelService {
    private relUrl = ConfigService.getApiEndpoint() + 'v1/projecteventrel/';

    constructor(
        private http: HttpClient,
        private eventService: EventService,
        private error: ErrorService
    ) { }

    updatePluginValidations(projectId:string, pluginValidations: ProjectPlugin[]): Observable<string[]> {
        return this.http.put<ProjectPlugin[]>(this.relUrl + projectId + '/pluginValidations', pluginValidations).pipe(
            tap(_ => this.eventService.addAlert(`updated project-settings for project: ${projectId}`)),
            catchError(this.error.handleError('plugin-validation.update', null))
        );
    }

}
